/* Account */
export const COMMON_TOAST = 'COMMON_TOAST';
export const COMMON_TOAST_RESET = 'COMMON_TOAST_RESET';
export const COMMON_TOAST_HIDE = 'COMMON_TOAST_HIDE';
